"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Tabs_1 = tslib_1.__importDefault(require("@material-ui/core/Tabs"));
var Tabs = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(StyledTabs, tslib_1.__assign({}, rest, { TabIndicatorProps: { children: react_1.default.createElement("div", null) }, classes: { indicator: 'indicator' } }), children));
};
exports.default = Tabs;
var StyledTabs = styled_components_1.default(Tabs_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    min-height: 0;\n  }\n  && .indicator {\n    background-color: ", ";\n    height: 0.4rem;\n  }\n"], ["\n  && {\n    min-height: 0;\n  }\n  && .indicator {\n    background-color: ", ";\n    height: 0.4rem;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[600];
});
var templateObject_1;
